module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Student/Student-ANG/src/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf
// module id = ../../../../../src/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf
// module chunks = styles